import LogIn from "./LogIn";


function DeveloperLogIn() {

  return <LogIn isDeveloper={true}/>;
}

export default DeveloperLogIn;
